import { render, staticRenderFns } from "./PlatformLayout.vue?vue&type=template&id=51aff6a1&scoped=true"
import script from "./PlatformLayout.vue?vue&type=script&lang=js"
export * from "./PlatformLayout.vue?vue&type=script&lang=js"
import style0 from "./PlatformLayout.vue?vue&type=style&index=0&id=51aff6a1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_068c914d031cd2060dd4a326836f4c99/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51aff6a1",
  null
  
)

export default component.exports